export default [
  {
    type: 'selection',
    width: 55,
    show: true,
  },
  {
    title: '编号',
    key: 'id',
    minWidth: 40,
    maxWidth: 100,
    show: true,
  },
  {
    title: '分类',
    key: 'category_id',
    slot: 'category',
    show: true,
  },
  {
    title: '标题',
    key: 'title',
    show: true,
  },
  {
    title: '排序',
    key: 'sort',
    show: true,
  },
  {
    title: '状态',
    key: 'status',
    slot: 'status',
    show: true,
  },
  {
    title: '添加时间',
    key: 'create_time',
    slot: 'create_time',
    show: true,
  },
  {
    title: '操作',
    key: 'action',
    slot: 'action',
    width: 120,
    align: 'center',
    fixed: 'right',
    show: true,
  },
]
